import React, { useState } from 'react';
import styles from './UnitOverview.module.css';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

const UnitOverview = ({ unit }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.overviewContainer}>
      <div className={styles.quickFacts}>
        <div className={styles.factItem}>
          <strong>{unit.Bedrooms}</strong> Bedroom
        </div>
        <div className={styles.factItem}>
          <strong>{unit.Bathrooms}</strong> Bath
        </div>
        <div className={styles.factItem}>
          <strong>{unit.SquareFeet} Sq.ft</strong>
        </div>
        <div className={styles.factItem}>
          <strong>${unit.RentAmount}/month</strong>
        </div>
      </div>

      <div className={styles.heroImageContainer}>
        <img
          src={unit.ImageGallery[0]}
          alt="Main Unit"
          className={styles.heroImage}
          onClick={() => setOpen(true)}
          style={{ cursor: 'pointer' }}
        />
      </div>

      <div className={styles.descriptionBox}>
        <h3>Description</h3>
        <p>{unit.Description || "A great place to call home! No additional details provided."}</p>
      </div>

      {open && (
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={unit.ImageGallery.map((img) => ({ src: img }))}
          index={0}
        />
      )}
    </div>
  );
};

export default UnitOverview;
